exports.responseHandler = async (input, callback) => {

    const tipo = input.metadata.KM_CHAT_CONTEXT.atendimento;

    const tipos = {
        "computadores": `- Drivers e/ou periféricos
- Softwares e/ou aplicativos
- Serviço de nuvem
- Suporte a antivírus
- Diagnóstico e manutenção preventiva`,
        "roteadores": `- Instalação
- Configuração
- Alteração de senha e/ou nome de rede
- Lentidão da rede`,
        "impressoras": `- Instalação
- Configuração
- Atualização
- Orientação de uso`,
        "smartphones": `- Conexões
- Senhas e bloqueio
- Contas e backup
- Instalação de Apps
- Limpeza de arquivos
- Migração de aparelho`,
        "smart": `- Instalação/desinstalação de aplicativos compatíveis
- Configuração de rede do dispositivo`,
        "assistente": `- Configuração de assistente virtual (Alexa, Google, Assistente, Siri, Bixby)`,
    }

    callback([{
        "message": "Nossos especialistas podem te ajudar com:"
    }, {
        "message": tipos[tipo]
    }, {
        "platform": "kommunicate",
        "metadata": {
            "contentType": "300",
            "templateId": "6",
            "payload": [{
                "title": "Tenho mais dúvidas",
                "message": "Tenho mais dúvidas",
                "replyMetadata": {
                    "KM_TRIGGER_EVENT": "Dúvidas"
                }
            }, {
                "title": "Agendar atendimento",
                "message": "Agendar atendimento",
                "replyMetadata": {
                    "KM_TRIGGER_EVENT": "Agendar atendimento"
                }
            }]
        }
    }])

}